import React from 'react';
import './WelcomePage.css';
import Welcome from '../../components/Welcome/Welcome';

const WelcomePage = () => {
  return (
    <div className="welcome-page">
    <Welcome />
    </div>
  );
};

export default WelcomePage;
